var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoicesIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7285 7.12506H8.32852C8.16939 7.12506 8.01677 7.18827 7.90425 7.3008C7.79173 7.41332 7.72852 7.56593 7.72852 7.72506V14.1251M7.72852 19.1251H13.7285H7.72852ZM7.72852 19.1251V14.1251V19.1251ZM7.72852 19.1251H2.32852C2.16939 19.1251 2.01677 19.0618 1.90425 18.9493C1.79173 18.8368 1.72852 18.6842 1.72852 18.5251V14.7251C1.72852 14.5659 1.79173 14.4133 1.90425 14.3008C2.01677 14.1883 2.16939 14.1251 2.32852 14.1251H7.72852V19.1251ZM13.7285 19.1251V7.12506V19.1251ZM13.7285 19.1251H19.1285C19.2876 19.1251 19.4403 19.0618 19.5528 18.9493C19.6653 18.8368 19.7285 18.6842 19.7285 18.5251V1.72506C19.7285 1.56593 19.6653 1.41332 19.5528 1.3008C19.4403 1.18828 19.2876 1.12506 19.1285 1.12506H14.3285C14.1694 1.12506 14.0168 1.18828 13.9043 1.3008C13.7917 1.41332 13.7285 1.56593 13.7285 1.72506V7.12506V19.1251Z",
    stroke: "#709506",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicesIcon5);
export default __webpack_public_path__ + "static/media/invoices-icon5.8621380c4a098b70bb824c19f3be0851.svg";
export { ForwardRef as ReactComponent };